import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import { errorMessage, infoMessage } from '../utils/toastMessage';
import { isShow } from '../service/cTest';



const Chance = () => {
    const [getIsShow,setIsShow]=useState(false)

    const navigate = useNavigate();
    const user = useSelector((state) => state.user)
    const handleClick = () => {
        if (user.value == "") {
            infoMessage("ابتدا وارد حساب خود شوید")
        }
        else {
            navigate("/dashboard/cTest")
        }
    }

    const handleIsShow=async()=>{
        try {
            const { status, data } = await isShow();
            if (status === 200) {
                console.log(data);
                setIsShow(data.is_show)
            }
        } catch (ex) {
        }
    }



    useEffect(() => {
        handleIsShow()
    }, [])
    return (
        <span onClick={handleClick}  style={{ width: "100%", height: "50px", backgroundColor: "red", color: "white", display: getIsShow ? "flex" : "none", justifyContent: "center", alignItems: "center" }}>
            شانستو تو گردونه شانس امتحان کن !!!
        </span>
    )
}


export default Chance